import { useEffect as a } from "react";
import { useLatestValue as f } from './use-latest-value.js';
function s(t, e, o, n) {
  var i = f(o);
  a(function () {
    if (!t) return;
    function r(d) {
      i.current(d);
    }
    return window.addEventListener(e, r, n), function () {
      return window.removeEventListener(e, r, n);
    };
  }, [t, e, n]);
}
export { s as useWindowEvent };